import * as z from "zod";
import { onboardingV2OverviewAnalyticsInputSchema } from "./overview-analytics-input";

export const onboardingV2OverviewStatsSchema = z.object({
  totalCount: z.number().int().min(0),
  completedCount: z.number().int().min(0),
  completedOnboardingsCount: z.number().int().min(0),
  helpRequestedCount: z.number().int().min(0),
  revenueOnboarded: z.number().min(0),
  averageCompletionTimeMinutes: z.number().min(0),
  averageCompletionPercentage: z.number().min(0).max(100),
  totalCountChange: z.number().nullable().optional(),
  completedCountChange: z.number().nullable().optional(),
  completedOnboardingsCountChange: z.number().nullable().optional(),
  helpRequestedCountChange: z.number().nullable().optional(),
  revenueOnboardedChange: z.number().nullable().optional(),
  averageCompletionTimeMinutesChange: z.number().nullable().optional(),
  averageCompletionPercentageChange: z.number().nullable().optional(),
  /**
   * Pre-computed rate deltas in percentage points (Issue 5A). The
   * server-side `analytics/changes.ts` helper owns the division-by-zero
   * and null-previous-period guards so the frontend can render these
   * directly without re-deriving.
   */
  completionRateChange: z.number().nullable().optional(),
  helpRequestedRateChange: z.number().nullable().optional(),
});

export const getOnboardingsV2OverviewStats = {
  name: "getOnboardingsV2OverviewStats" as const,
  input: onboardingV2OverviewAnalyticsInputSchema,
  output: onboardingV2OverviewStatsSchema,
};

export type GetOnboardingsV2OverviewStatsInput = z.infer<
  typeof getOnboardingsV2OverviewStats.input
>;
export type GetOnboardingsV2OverviewStatsOutput = z.infer<
  typeof getOnboardingsV2OverviewStats.output
>;
